/**
 *
 * @class WishlistButton
 * @param {button} Required DOM Element
 *
 *
 * Markup Expectation
 * <anyValidHTMLElement class="SomeSelector" data-product-id="{{ product.id | json }}" data-variant='{{ product.selected_or_first_available_variant | json | escape }}' data-product-handle="{{ product.handle }}" data-product-name="{{ product.title | escape }}">
 *  <label class="wishlist-label">{{ 'product.labels.add_to_wishlist' | t }}</label>
 * </anyValidHTMLElement>
 *
 * Markup Data Attributes
 * @param {data-product-id} Required Product ID
 * @param {data-variant} Required Variant JSON for the variant being added to the wishlist. Can be static first variant or dynamic based on selectors.
 * @param {data-product-handle} Optional If used on Collections template, provide a handle to the product for Wishlist link back to product & variant.
 * @param {data-product-name} Optional If used, provide a name for the product to include in button text.
 *
 */

class WishlistButton {
  constructor(button) {
    this.button = button;

    this._init();
  }

  _toggleButtonText(button, state, title) {
    if (title) {
      // If a product name is provided, create string to add to button text
      var product_name_add = title + " ";
      var product_name_added = title + " is ";
    } else {
      // Empty string if not product name is provided
      var product_name_add = "";
      var product_name_added = "";
    }
    /*
    const wishlistAddText = window.theme.addToWishlist || "Add to Wishlist";
    const wishlistAddedText = window.theme.addedToWishlist || "In your Wishlist";
    */
    const wishlistAddText = "Add " + product_name_add + "to Wishlist";
    const wishlistAddedText = product_name_added + "In Your Wishlist";
    const wishlistLabel = button.querySelector(".product-card__wishlist-label") || null;

    if (state === true) {
      wishlistLabel ? (wishlistLabel.textContent = wishlistAddedText) : null;
      button.classList.add("added");
    } else {
      wishlistLabel ? (wishlistLabel.textContent = wishlistAddText) : null;
      button.classList.remove("added");
    }
  }

  _fetchWishlist() {
    return new Promise((resolve, reject) => {
      window._swat.fetch(products => {
        if (products) resolve(products);
        else reject;
      });
    });
  }

  _checkWishlist(wishlist, variantId) {
    return new Promise((resolve, reject) => {
      if (!wishlist || !variantId) reject;

      if (wishlist.length) {
        const product = wishlist.find(({ epi }) => epi === variantId) || null;
        product ? resolve(true) : resolve(false);
      }
    });
  }

  _addWishlist(variant, productId, productHandle) {
    return new Promise((resolve, reject) => {
      const title = variant.title;
      const url = productHandle
        ? `${window.location.origin}/products/${productHandle}?variant=${variant.id}`
        : window.location.href;
      window._swat.addToWishList(
        {
          epi: variant.id,
          du: url,
          empi: productId,
          iu: variant.featured_image.src.replace("https://", "//"),
          pr: variant.price / 100.0,
          variants: [{ [title]: variant.id }]
        },
        response => {
          if (response.epi) resolve(response);
          else reject;
        }
      );
    });
  }

  _init() {
    const wishlistButton = this.button;
    let currentWishlist = [];

    if (!wishlistButton) return;

    let variant = { ...JSON.parse(wishlistButton.dataset.variant) } || null;
    const productId = wishlistButton.dataset.productId || null;
    const productUrl = wishlistButton.dataset.productHandle || null;
    let productName = wishlistButton.dataset.productName || null;

    const swymCallbackFn = async () => {
      const wishlistItems = await this._fetchWishlist();
      currentWishlist = [...wishlistItems];
      const currentProduct = await this._checkWishlist(
        currentWishlist,
        variant.id
      );
      currentProduct
        ? this._toggleButtonText(wishlistButton, true, productName)
        : this._toggleButtonText(wishlistButton, false, productName);
    };

    // Fired when product variants are changed
    document.addEventListener("variant:changed", async event => {
      if (!event.detail.variant) return;
      variant = { ...event.detail.variant };

      const currentProduct = await this._checkWishlist(
        currentWishlist,
        variant.id
      );
      currentProduct
        ? this._toggleButtonText(wishlistButton, true)
        : this._toggleButtonText(wishlistButton, false);
      wishlistButton.setAttribute("data-variant", variant);
    });

    wishlistButton.addEventListener("click", async event => {
      try {
        // Debug
        // console.log(`${variant.title} added to wishlist`);
        await this._addWishlist(variant, productId, productUrl);
        const wishlistItems = await this._fetchWishlist();
        currentWishlist = [...currentWishlist, ...wishlistItems];
        this._toggleButtonText(wishlistButton, true, productName);
      } catch (error) {
        console.log("There was an error.", error);
      }
    });

    // Push to Swym when it's loaded
    if (!window.SwymCallbacks) window.SwymCallbacks = [];
    window.SwymCallbacks.push(swymCallbackFn);
  }
}

const pdpWishlist = () => {
  const pdpButton = document.getElementById("Product_Form_Wishlist");

  new WishlistButton(pdpButton);
};

const collectionWishlist = () => {
  const collectionBtn = document.querySelectorAll(
    ".product-card__wishlist-button"
  );

  for (const button of collectionBtn) {
    new WishlistButton(button);
  }
};

$(function() {
  $(document).ready(function() {
    pdpWishlist();
    collectionWishlist();
  });
});
